export default __webpack_public_path__ + "static/LogoConduction-44e291f293a61bd4dab3426045619e3c.svg";